import React from "react"
import { useStaticQuery, graphql } from "gatsby"

// Data
import siteContent from "../../content/siteContent"

// Styles
import * as styles from "./SiteFooter.module.scss"

// Components
import NavigationFooter from "./NavigationFooter"
import FooterCTA from "./FooterCTA"
import FooterContactCTA from "./FooterContactCTA"

const SiteFooter = () => {
    const data = useStaticQuery(graphql`
        query FooterQuery {
            wp {
                footerSettings {
                    footer_legals {
                        legals
                    }
                    footer_ctas {
                        fieldGroupName
                        ctas {
                            buttonText
                            text
                            title
                            link {
                                url
                            }
                        }
                    }
                    footer_social_cta {
                        socialCta {
                            instagram
                            facebook
                            buttonText
                            title
                            twitter
                            link {
                                url
                            }
                        }
                    }
                    footer_navigation {
                        navigation {
                            ... on WpPage {
                                id
                                title
                                link
                            }
                        }
                    }
                }
            }
        }
    `)

    const footerContent = data.wp.footerSettings

    return (
        <div className={styles.SiteFooter}>
            <div className={styles.ctas}>
                {footerContent.footer_ctas && footerContent.footer_ctas.ctas.map((cta, index) => <FooterCTA key={`footer-cta-${index}`} {...cta} />)}
                <FooterContactCTA {...footerContent.footer_social_cta.socialCta} />
            </div>

            <div className={styles.subFooter}>
                {footerContent.footer_navigation.navigation && <NavigationFooter navigation={footerContent.footer_navigation.navigation} />}

                {footerContent.footer_legals.legals && <span>{footerContent.footer_legals.legals}</span>}
            </div>
        </div>
    )
}

export default SiteFooter
